/**
 * BitBard GA4 helpers.
 *
 * Operator-only surfaces (Reply Ops / Opportunities) must NEVER inflate
 * public engagement totals. Also skip when an admin JWT is present — the
 * logged-in operator browsing any tab is not public traffic.
 */

const INTERNAL_TABS = new Set(['opportunities']);

const TAB_TITLES = {
  live: 'Troupe Feed',
  characters: 'Character Chat',
  nodes: 'Knowledge Map',
  horatio: 'Ask Horatio',
  imm: 'Immortalize',
  opportunities: 'Opportunities',
};

const TAB_TO_PATH = {
  live: '/live',
  wizard: '/wizard',
  characters: '/characters',
  nodes: '/knowledge-map',
  horatio: '/horatio',
  imm: '/immortalize',
  opportunities: '/opportunities',
};

export function isInternalTraffic(tabName) {
  if (INTERNAL_TABS.has(tabName)) return true;
  try {
    if (localStorage.getItem('admin_jwt')) return true;
  } catch (_) {
    /* ignore */
  }
  return false;
}

export function trackTabPageView(tabName) {
  if (!window.gtag) return;
  if (isInternalTraffic(tabName)) {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[GA] skipped internal traffic for tab:', tabName);
    }
    return;
  }
  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: TAB_TO_PATH[tabName] || `/${tabName}`,
    page_title: `BitBard - ${TAB_TITLES[tabName] || tabName}`,
  });
}

export { TAB_TITLES, TAB_TO_PATH };
